import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { selectors as versionSelectors } from 'frontend/state/reducers/version';

const UpdateAwareLink = props => {
  const { newVersionAvailable, to, ...rest } = props;
  delete rest.dispatch;

  if (newVersionAvailable) {
    return <a href={to} {...rest}>{props.children}</a>;
  }

  return <Link to={to} {...rest}>{props.children}</Link>;
};

UpdateAwareLink.propTypes = {
  newVersionAvailable: PropTypes.bool,
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

UpdateAwareLink.defaultProps = {
  newVersionAvailable: false,
};

const mapStateToProps = state => ({
  newVersionAvailable: versionSelectors.newVersionAvailable(state),
});

export default connect(mapStateToProps)(UpdateAwareLink);
